import useJSTEventLog from "@indeed/tare/eventLog/JSTEventLog";
import { useCallback } from "react";

import { useClose } from "../../../shared/native-modules/core/useClose";

/**
 * Hook that returns a function to close ViewJob with logging.
 * This wraps the generic useClose hook with ViewJob-specific logging.
 */
export function useCloseVJ(): () => void {
  const JSTEventLog = useJSTEventLog();

  const close = useClose();

  return useCallback(() => {
    void close();
    void JSTEventLog.logTapButton("rn-view-job-bottom-sheet", "close");
  }, [JSTEventLog, close]);
}
